/**
 * formatHours
 * Displays whole numbers without decimal (e.g. 8h), and fractional numbers with one decimal place (e.g. 8.5h).
 */
export const formatHours = (value) => {
  const n = Number(value || 0);
  return n % 1 === 0 ? `${n.toFixed(0)}h` : `${n.toFixed(1)}h`;
};

/**
 * formatPremiumHours
 * Returns +{value}{label} format for positive premium hours (OT/DT), preserving decimals.
 * Returns null if the value is <= 0.
 */
export const formatPremiumHours = (value, label) => {
  const n = Number(value || 0);
  if (n <= 0) return null;
  return `+${n % 1 === 0 ? n.toFixed(0) : n.toFixed(1)}${label}`;
};
